<template lang="pug">
  v-touch(@swipeup="goAboutPage", @scroll="goAboutPage").home.page
    .wrapper
      LogoWhite#logoHome
      router-link(to="/sobre")#seeMore
        span sobre
        ArrowDown
</template>

<script>
import './style.sass'
import LogoWhite from '@/assets/svg/logo/white.svg'
import ArrowDown from '@/assets/svg/md-arrow-down.svg'
import router from '@/router'


export default {
  name: 'Home',
  components: {
    LogoWhite,
    ArrowDown
  },
  computed: {
  },
  methods: {
    goAboutPage() {
      router.push({ name: 'about' })
    }
  },
  created () {
    window.addEventListener('scroll', this.goAboutPage)
  },
  mounted () {
    this.$store.commit('setLoading', false)
  },
  destroyed () {
    window.removeEventListener('scroll', this.goAboutPage)
  }
}
</script>